class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.busy = false;
    this.MAX_ONE_PRO = 6;

    this.handleClick = this.handleClick.bind(this);
    this.handleDocumentPointerUp = this.handleDocumentPointerUp.bind(this);
    this.handleKeyup = this.handleKeyup.bind(this);

    this.addEventListener('click', this.handleClick);
    this.addEventListener('keyup', this.handleKeyup);

    document.addEventListener(
      'pointerup',
      this.handleDocumentPointerUp,
      true
    );

    this.setHeaderCartIconAccessibility();
  }


  handleDocumentPointerUp(event) {
    if (!this.classList.contains('active')) return;

    const closeButton = this.querySelector('.bz-cart-close');

    if (!closeButton) return;

    const rect = closeButton.getBoundingClientRect();
    const x = event.clientX;
    const y = event.clientY;

    const hit =
      x >= rect.left &&
      x <= rect.right &&
      y >= rect.top &&
      y <= rect.bottom;

    if (!hit) return;

    event.preventDefault();
    this.close();
  }


  handleClick(event) {
    const target = event.target;

    // Checkout is handled by Shopify's native cart POST (name="checkout").
    // Do not preventDefault() or otherwise intercept this interaction.
    if (target.closest('.bz-cart-checkout')) {
      return;
    }

    const closeButton = target.closest('.bz-cart-close');

    if (closeButton) {
      event.preventDefault();
      this.close();
      return;
    }

    if (target.id === 'CartDrawer-Overlay') {
      event.preventDefault();
      this.close();
      return;
    }

    const plusButton = target.closest('[data-bz-plus]');

    if (plusButton) {
      event.preventDefault();

      if (this.busy) return;

      const quantityElement =
        this.querySelector('.bz-quantity-value');

      if (!quantityElement) return;

      const currentQuantity = parseInt(
        quantityElement.textContent.trim(),
        10
      );

      if (Number.isNaN(currentQuantity)) return;

      if (currentQuantity >= this.MAX_ONE_PRO) {
        this.showQuantityLimitMessage();
        return;
      }

      this.updateOneProQuantity(
        currentQuantity + 1
      );

      return;
    }

    const minusButton = target.closest('[data-bz-minus]');

    if (minusButton) {
      event.preventDefault();

      if (this.busy) return;

      const quantityElement =
        this.querySelector('.bz-quantity-value');

      if (!quantityElement) return;

      const currentQuantity = parseInt(
        quantityElement.textContent.trim(),
        10
      );

      if (Number.isNaN(currentQuantity)) return;

      this.updateOneProQuantity(
        Math.max(
          0,
          currentQuantity - 1
        )
      );

      return;
    }

    const duoButton = target.closest('[data-bz-add-duo]');

    if (duoButton) {
      event.preventDefault();

      if (this.busy) return;

      this.updateOneProQuantity(2);

      return;
    }

    const addButton = target.closest('[data-bz-add-product]');

    if (addButton) {
      event.preventDefault();

      if (this.busy) return;

      const variantId =
        addButton.dataset.variantId;

      if (!variantId) return;

      this.addProduct(variantId);

      return;
    }
  }


  handleKeyup(event) {
    if (event.code !== 'Escape') return;

    const modal =
      this.querySelector(
        '[data-bz-guarantee-modal]'
      );

    if (
      modal &&
      modal.classList.contains('is-open')
    ) {
      modal.classList.remove('is-open');

      modal.setAttribute(
        'aria-hidden',
        'true'
      );

      return;
    }

    this.close();
  }


  setHeaderCartIconAccessibility() {
    const cartLink =
      document.querySelector(
        '#cart-icon-bubble'
      );

    if (!cartLink) return;

    cartLink.setAttribute(
      'role',
      'button'
    );

    cartLink.setAttribute(
      'aria-haspopup',
      'dialog'
    );

    cartLink.addEventListener(
      'click',
      (event) => {
        event.preventDefault();

        this.open(cartLink);
      }
    );

    cartLink.addEventListener(
      'keydown',
      (event) => {
        if (
          event.code.toUpperCase() ===
            'SPACE' ||
          event.code.toUpperCase() ===
            'ENTER'
        ) {
          event.preventDefault();

          this.open(cartLink);
        }
      }
    );
  }


  open(triggeredBy) {
    if (triggeredBy) {
      this.setActiveElement(
        triggeredBy
      );
    }

    this.classList.add(
      'animate'
    );

    requestAnimationFrame(() => {
      this.classList.add(
        'active'
      );
    });

    document.body.classList.add(
      'overflow-hidden'
    );

    this.updateQuantityLimitState();
  }


  close() {
    this.classList.remove(
      'active'
    );

    document.body.classList.remove(
      'overflow-hidden'
    );

    const modal =
      this.querySelector(
        '[data-bz-guarantee-modal]'
      );

    if (modal) {
      modal.classList.remove(
        'is-open'
      );

      modal.setAttribute(
        'aria-hidden',
        'true'
      );
    }

    this.hideQuantityLimitMessage();

    if (this.activeElement) {
      try {
        this.activeElement.focus();
      } catch (e) {}
    }
  }


  getBreazLocale() {
    const locale =
      this.dataset.breazLocale ||
      document.documentElement.lang ||
      'en';

    return locale.toLowerCase().startsWith('nl')
      ? 'nl'
      : 'en';
  }


  getBreazText(key) {
    const texts = {
      en: {
        cart: 'CART',
        max: 'Maximum 6 ONE PROs per order.'
      },
      nl: {
        cart: 'WINKELWAGEN',
        max: 'Maximaal 6 ONE PROs per bestelling.'
      }
    };

    return texts[this.getBreazLocale()]?.[key] || texts.en[key];
  }


  getOneProProductId() {
    return 15846297305461;
  }


  async updateOneProQuantity(
    targetQuantity
  ) {
    targetQuantity = Math.max(
      0,
      Math.min(
        this.MAX_ONE_PRO,
        parseInt(
          targetQuantity,
          10
        ) || 0
      )
    );

    if (this.busy) return;

    this.busy = true;

    this.setButtonsDisabled(true);

    try {
      const productCard =
        this.querySelector(
          '.bz-cart-product'
        );

      if (!productCard) {
        throw new Error(
          'ONE PRO cart product not found.'
        );
      }

      const lineKeysString =
        productCard.dataset.bzLineKeys ||
        '';

      const lineKeys =
        lineKeysString
          .split('|||')
          .map(
            (key) => key.trim()
          )
          .filter(Boolean);

      if (!lineKeys.length) {
        throw new Error(
          'ONE PRO cart line keys not found.'
        );
      }

      const updates = {};

      lineKeys.forEach(
        (lineKey, index) => {
          updates[lineKey] =
            index === 0
              ? targetQuantity
              : 0;
        }
      );

      const response =
        await fetch(
          `${window.Shopify.routes.root}cart/update.js`,
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json',

              Accept:
                'application/json'
            },

            body: JSON.stringify({
              updates,

              sections:
                'cart-drawer,cart-icon-bubble',

              sections_url:
                window.location.pathname
            })
          }
        );

      if (!response.ok) {
        throw new Error(
          'Unable to update cart.'
        );
      }

      const parsedState =
        await response.json();

      this.renderContents(
        parsedState,
        true
      );

    } catch (error) {
      console.error(
        'BREAZ cart update error:',
        error
      );

      this.busy = false;

      this.setButtonsDisabled(
        false
      );

      this.updateQuantityLimitState();
    }
  }


  async addProduct(
    variantId
  ) {
    if (
      !variantId ||
      this.busy
    ) {
      return;
    }

    this.busy = true;

    this.setButtonsDisabled(
      true
    );

    try {
      const response =
        await fetch(
          `${window.Shopify.routes.root}cart/add.js`,
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json',

              Accept:
                'application/json'
            },

            body: JSON.stringify({
              items: [
                {
                  id:
                    Number(
                      variantId
                    ),

                  quantity: 1
                }
              ],

              sections:
                'cart-drawer,cart-icon-bubble',

              sections_url:
                window.location.pathname
            })
          }
        );

      if (!response.ok) {
        throw new Error(
          'Unable to add product.'
        );
      }

      const parsedState =
        await response.json();

      try {
        const cart =
          await this.getCart();

        parsedState.item_count =
          cart.item_count;
      } catch (e) {}

      this.renderContents(
        parsedState,
        false
      );

    } catch (error) {
      console.error(
        'BREAZ cart add error:',
        error
      );

      this.busy = false;

      this.setButtonsDisabled(
        false
      );

      this.updateQuantityLimitState();
    }
  }


  async getCart() {
    const response =
      await fetch(
        `${window.Shopify.routes.root}cart.js`,
        {
          headers: {
            Accept:
              'application/json'
          }
        }
      );

    if (!response.ok) {
      throw new Error(
        'Cart could not be loaded.'
      );
    }

    return response.json();
  }


  renderContents(
    parsedState,
    keepOpen = true
  ) {
    const cartDrawerHTML =
      parsedState.sections?.[
        'cart-drawer'
      ];

    const cartIconHTML =
      parsedState.sections?.[
        'cart-icon-bubble'
      ];

    if (cartDrawerHTML) {
      const parsedDocument =
        new DOMParser().parseFromString(
          cartDrawerHTML,
          'text/html'
        );

      const newCartDrawer =
        parsedDocument.querySelector(
          '#CartDrawer'
        );

      const newCartElement =
        parsedDocument.querySelector(
          'cart-drawer'
        );

      if (newCartDrawer) {
        const currentCartDrawer =
          this.querySelector(
            '#CartDrawer'
          );

        if (currentCartDrawer) {
          currentCartDrawer.innerHTML =
            newCartDrawer.innerHTML;
        }
      }

      if (newCartElement) {
        if (newCartElement.dataset.breazLocale) {
          this.dataset.breazLocale =
            newCartElement.dataset.breazLocale;
        }

        this.classList.toggle(
          'is-empty',
          newCartElement.classList.contains(
            'is-empty'
          )
        );
      } else {
        const isEmpty =
          !parsedState.item_count ||
          parsedState.item_count === 0;

        this.classList.toggle(
          'is-empty',
          isEmpty
        );
      }
    }

    const cartTitle =
      this.querySelector(
        '.bz-cart-title'
      );

    if (cartTitle) {
      const itemCount =
        Number(
          parsedState.item_count || 0
        );

      const cartLabel =
        this.getBreazText('cart');

      cartTitle.textContent =
        itemCount > 0
          ? `${cartLabel} (${itemCount})`
          : cartLabel;
    }

    if (cartIconHTML) {
      const parsedIconDocument =
        new DOMParser().parseFromString(
          cartIconHTML,
          'text/html'
        );

      const newIcon =
        parsedIconDocument.querySelector(
          '#cart-icon-bubble'
        );

      const currentIcon =
        document.querySelector(
          '#cart-icon-bubble'
        );

      if (
        newIcon &&
        currentIcon
      ) {
        currentIcon.innerHTML =
          newIcon.innerHTML;
      }
    }

    if (
      keepOpen ||
      this.classList.contains(
        'active'
      )
    ) {
      this.classList.add(
        'animate'
      );

      requestAnimationFrame(() => {
        this.classList.add(
          'active'
        );
      });

      document.body.classList.add(
        'overflow-hidden'
      );
    }

    this.busy = false;

    this.setButtonsDisabled(
      false
    );

    this.updateQuantityLimitState();
  }


  updateQuantityLimitState() {
    const plusButton =
      this.querySelector(
        '[data-bz-plus]'
      );

    const quantityElement =
      this.querySelector(
        '.bz-quantity-value'
      );

    if (
      !plusButton ||
      !quantityElement
    ) {
      return;
    }

    const currentQuantity =
      parseInt(
        quantityElement.textContent.trim(),
        10
      );

    if (
      Number.isNaN(
        currentQuantity
      )
    ) {
      return;
    }

    const atLimit =
      currentQuantity >=
      this.MAX_ONE_PRO;

    if (atLimit) {

      /*
       * DO NOT disable the button.
       * It must remain clickable so
       * the max quantity message
       * can appear.
       */

      plusButton.classList.add(
        'bz-quantity-limit-reached'
      );

      plusButton.setAttribute(
        'aria-disabled',
        'true'
      );

      plusButton.setAttribute(
        'aria-label',
        'Maximum 6 ONE PROs per order'
      );

      plusButton.setAttribute(
        'title',
        'Maximum 6 ONE PROs per order'
      );

    } else {

      plusButton.classList.remove(
        'bz-quantity-limit-reached'
      );

      plusButton.removeAttribute(
        'aria-disabled'
      );

      plusButton.setAttribute(
        'aria-label',
        'Increase quantity'
      );

      plusButton.removeAttribute(
        'title'
      );
    }
  }


  showQuantityLimitMessage() {
    let message =
      this.querySelector(
        '.bz-quantity-limit-message'
      );

    if (!message) {
      const quantityControls =
        this.querySelector(
          '.bz-quantity-value'
        )?.closest(
          '.bz-quantity'
        ) ||
        this.querySelector(
          '[data-bz-plus]'
        )?.parentElement;

      if (!quantityControls) {
        return;
      }

      message =
        document.createElement(
          'div'
        );

      message.className =
        'bz-quantity-limit-message';

      message.textContent =
        this.getBreazText('max');

      quantityControls.insertAdjacentElement(
        'afterend',
        message
      );
    }

    message.classList.add(
      'is-visible'
    );

    clearTimeout(
      this.quantityLimitTimeout
    );

    this.quantityLimitTimeout =
      setTimeout(() => {
        this.hideQuantityLimitMessage();
      }, 3000);
  }


  hideQuantityLimitMessage() {
    const message =
      this.querySelector(
        '.bz-quantity-limit-message'
      );

    if (!message) return;

    message.classList.remove(
      'is-visible'
    );
  }


  setButtonsDisabled(
    disabled
  ) {
    this.querySelectorAll(
      '[data-bz-plus], ' +
      '[data-bz-minus], ' +
      '[data-bz-add-duo], ' +
      '[data-bz-add-product]'
    ).forEach(
      (button) => {
        button.disabled =
          disabled;
      }
    );

    if (!disabled) {
      this.updateQuantityLimitState();
    }
  }


  setActiveElement(
    element
  ) {
    this.activeElement =
      element;
  }
}


if (
  !customElements.get(
    'cart-drawer'
  )
) {
  customElements.define(
    'cart-drawer',
    CartDrawer
  );
}